var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDragDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.25a.75.75 0 0 1 .102 1.493L17 15.75H6a.75.75 0 0 1-.102-1.493L6 14.25h11zm0-5a.75.75 0 0 1 .102 1.493L17 10.75H6a.75.75 0 0 1-.102-1.493L6 9.25h11z",
    fill: "#778699",
    fillRule: "nonzero"
  })));
}

export default SvgIconDragDrop;